import { useAuth0 } from '@auth0/auth0-react';
import { useAtomValue } from 'jotai';
import { useCallback } from 'react';

import { getBranches } from '@/apis/branches';
import { domainCodeAtom } from '@australiangreens/ag-internal-components';
import { labelSorting } from '@/util/labelSorting';

export const useLookupBranches = () => {
  const { getAccessTokenSilently } = useAuth0();
  const domainCode = useAtomValue(domainCodeAtom);

  return useCallback(
    async (lookupValue: string) => {
      const token = await getAccessTokenSilently();
      const domainState =
        !domainCode || ['ag', 'fedmps'].includes(domainCode) ? '' : domainCode.toUpperCase();

      return (await getBranches(token, domainState, lookupValue))
        .map((x) => {
          return {
            id: x.value,
            label: domainState === '' ? x.state + ' - ' + x.label : x.label,
          };
        })
        .sort(labelSorting);
    },
    [domainCode, getAccessTokenSilently]
  );
};
